import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  channelsSection: {
    marginTop: 16
  },
  excludeChannelsTitle: {
    marginTop: 16
  }
})

export default useStyles
